import React, { useState } from 'react';
import NavItem from './../NavItem/NavItem';
import { useNavigate, useLocation } from "react-router-dom";
import CloseIcon from '@material-ui/icons/Close';
import Images from '../../Images';
import { Link } from 'react-router-dom';
import { getToken } from '../../authetication/loginState';

const Navlist = ({ loginState, open, setOpen, mobileState }) => {
  const [open_students_dropdown, setOpen_students_dropdown] = useState(false);
  let navigate = useNavigate();
  const [open_recruiters_dropdown, setOpen_recruiters_dropdown] = useState(false);
  const location = useLocation();

  const handleSmoothScroll = (e, sectionId) => {
    e.preventDefault();
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const change_students_dropdown = (e) => {
    e.preventDefault();
    setOpen_students_dropdown(!open_students_dropdown);
  };

  const change_recruiters_dropdown = (e) => {
    e.preventDefault();
    setOpen_recruiters_dropdown(!open_recruiters_dropdown);
  };

  const getDropbtnClass = () => {
    return location.pathname === '/' ? 'dropbtn home' : 'dropbtn other';
  };
  
  // If mobile, return mobile nav
  if (mobileState) {
    return (
      <>
        <div 
          className={"close-icon-box"}
        > 
            <img
              src={Images.NORA_LOGO} 
              alt="Nora AI"
              onClick={() => navigate("/")}
              className="navbar__logoOpenimg"
            />
          <button className="close-icon" onClick={() => setOpen(!open)}>
            <CloseIcon />
          </button>
        </div>
        
        {getToken() ? (
          <div className="mobile-redirect">
            <a href="/mockInterviewerInput" className="mobile-nav-item">
              <li>Mock Interviewer</li>
            </a>

            <a href="mailto:hannan@norahq.com" className="mobile-nav-item">
              <li>Contact</li>
            </a>

            <div 
              onClick={loginState?.logoutUser}
              className="mobile-nav-item"
              style={{ cursor: 'pointer' }}
            >
              <li>Logout</li>
            </div>
          </div>
        ) : (
          <div className="mobile-redirect">
            <Link to={'/login'} className="mobile-nav-item">
              <li>Sign Up</li>
            </Link>
            <a href="https://nora.promotekit.com" className="mobile-nav-item" target="_blank" rel="noopener noreferrer">
              <li>Affiliate</li>
            </a>
            <a href="https://interview.norahq.com/interview-guides" className="mobile-nav-item" target="_blank" rel="noopener noreferrer">
              <li>Company Questions</li>
            </a>
            <a href="https://norahq.com/" className="mobile-nav-item">
              <li>Recruiters</li>
            </a>
          </div>
        )}
      </>
    );
  }

  // Desktop nav - return elements that will be direct children of navbar
  return (
    <>
      {/* Navigation Links - only show when not logged in */}
      {!getToken() && (
        <div className="nav_center">
          <a href="#how-it-works" className="nav_link" onClick={(e) => handleSmoothScroll(e, 'how-it-works')}>How It Works</a>
          <a href="#testimonials" className="nav_link" onClick={(e) => handleSmoothScroll(e, 'testimonials')}>Testimonials</a>
          <a href="#faqs" className="nav_link" onClick={(e) => handleSmoothScroll(e, 'faqs')}>FAQs</a>
          {/* <a href="https://nora.promotekit.com" className="nav_link" target="_blank" rel="noopener noreferrer">Affiliate</a> */}
          <a href="https://interview.norahq.com/interview-guides" className="nav_link" target="_blank" rel="noopener noreferrer">Company Questions</a>
        </div>
      )}

      {/* Right side buttons/nav items */}
      {!getToken() ? (
        <div className="nav_buttons">
          {/* <button className="nora-button2-style" onClick={() => navigate("/login")}>
            Sign In
          </button> */}
          <button className="nora-button-style" onClick={() => navigate("/login")}>
            Try for free today &nbsp;→
          </button>
        </div>
      ) : (
        <div className="nav_logged_in">
          <NavItem link="/mockInterviewerInput" name="Home" />
          <a href="mailto:hannan@norahq.com" className="navItem other">
            Contact
          </a>
          <div className="dropdown">
            <div className="students-nav"></div>
            <div className={getDropbtnClass()} name="User">
              <button className="nora-button-style" onClick={loginState?.logoutUser}>
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navlist;